import * as React from 'react';
export var Tooltip = function (_a) {
    var children = _a.children, _b = _a.margin, margin = _b === void 0 ? 'mb-8' : _b, title = _a.title, _c = _a.width, width = _c === void 0 ? 'w-32' : _c;
    return (<div className='relative flex flex-col items-center group'>
		{children}
		<div className={"absolute bottom-0 flex flex-col items-center invisible group-hover:visible ".concat(width, " ").concat(margin)}>
			<span className='relative z-10 p-2 text-xs leading-none text-white whitespace-no-wrap bg-gray-700 shadow-lg rounded-md'>
				{title}
			</span>
			<div className='w-3 h-3 -mt-2 transform rotate-45 bg-gray-700'/>
		</div>
	</div>);
};
